import {Component, EventEmitter, Inject, OnInit} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {DateHelper} from "../../../_helpers/date.helper";
import {Router} from "@angular/router";

@Component({
    selector: 'modal-notification',
    templateUrl: './notification.modal.html',
})
export class NotificationModal implements OnInit {
    public result = new EventEmitter();
    public dateHelper = DateHelper;
    constructor(
        public dialogRef: MatDialogRef<NotificationModal>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router,
    ) {}

    ngOnInit() {

    }

    toNotificationSource(d: any) {
        switch (d.notificationType) {
            case 'NEW_SUPPORT_TICKET':
            case 'REPLY_SUPPORT_TICKET':
            case 'CLOSE_SUPPORT_TICKET': {
                this.router.navigate([`/wallet-support/${d.referenceTableId}/conversation`]).then(_ => {
                    this.dialogRef.close();
                })
                break;
            }
            case 'CEU_EVENT_REQUEST': {
                this.router.navigate([`/ceu`]).then(_ => {
                    this.dialogRef.close();
                })
                break;
            }
        }

    }

    async markAsRead() {
        this.result.emit(true);
        this.dialogRef.close();
    }

    async closeDialog() {
        this.dialogRef.close();
    }
}